import request from '@/services/axios'

//PPT模版分页列表
export const getPPTPageList = (data:any)=>{
    return request.post('/api/ppt-template/page', data)
}

//获取PPT模版详情
export const getPPTemplateDetail = (data:any)=>{
    return request.post('/api/ppt-template/get', data)
}

//获取PPT模版详情预览
export const getPPTemplatePreview = (data:any)=>{
    return request.post('/api/ppt-template/preview', data)
}

//获取PPT模版收藏列表
export const getPPTemplateFavoritesList = (data:any)=>{
    return request.post('/api/ppt-template/favorites/page', data)
}

//获取PPT模版历史列表
export const getPPTemplateHistoryList = (data:any)=>{
    return request.post('/api/ppt-template/history/page', data)
}


//获取筛选分类及标签
export const getPPTemplateCategories = (data:any)=>{
    return request.post('/api/ppt-template/categories', data)
}
